import React, { Component } from "react";
import "./Footer.css";
import { APP_VERSION } from "./Version";

export class Footer extends Component {

    render() {
        return(
            <div className="container foot">
                <span>Version: {APP_VERSION}</span>
            </div>
        )
    }




}
